import * as ActionTypes from '../../../components/SearchForm/actionTypes.js';
import { slicePrefix } from '../../../components/SearchForm/redux/utils.js';
// TEST!!!
export const TRAVEL_TYPE_CHANGED = slicePrefix(ActionTypes.TravelTypeChanged);
export const TRAVEL_TYPE_FUNCTION_CHANGED = slicePrefix(ActionTypes.FunctionTravelTypeChanged);
export const DESTINATION_FIELD_VALUE_CHANGED = slicePrefix(ActionTypes.destinationField.ValueChanged);
export const DESTINATION_FIELD_FUNCTION_VALUE_CHANGED = slicePrefix(ActionTypes.destinationField.FunctionValueChanged);
export const DESTINATION_FIELD_RESET_CLICKED = slicePrefix(ActionTypes.destinationField.ResetClicked);
export const AIRPORTS_FIELD_VALUE_CHANGED = slicePrefix(ActionTypes.airportsField.ValueChanged);
export const AIRPORTS_FIELD_FUNCTION_VALUE_CHANGED = slicePrefix(ActionTypes.airportsField.FunctionValueChanged);
export const AIRPORTS_FIELD_RESET_CLICKED = slicePrefix(ActionTypes.airportsField.ResetClicked);
export const AIRPORTS_FIELD_SUGGESTIONS_NO_MATCH = slicePrefix(ActionTypes.airportsField.SuggestionsNoMatch);
export const TRAVELLERS_FIELD_VALUE_CHANGED = slicePrefix(ActionTypes.travellersField.ValueChanged);
export const TRAVELLERS_FIELD_FUNCTION_VALUE_CHANGED = slicePrefix(ActionTypes.travellersField.FunctionValueChanged);
export const TRAVELLERS_FIELD_RESET_CLICKED = slicePrefix(ActionTypes.travellersField.ResetClicked);
export const TRAVELLERS_FIELD_MULTIROOM_VALUE_CHANGED = slicePrefix(ActionTypes.travellersFieldMultiroom.ValueChanged);
export const TRAVELLERS_FIELD_MULTIROOM_FUNCTION_VALUE_CHANGED = slicePrefix(ActionTypes.travellersFieldMultiroom.FunctionValueChanged);
export const TRAVELLERS_FIELD_MULTIROOM_RESET_CLICKED = slicePrefix(ActionTypes.travellersFieldMultiroom.ResetClicked);
export const TRAVEL_PERIOD_FIELD_VALUE_CHANGED = slicePrefix(ActionTypes.travelPeriodField.ValueChanged);
export const TRAVEL_PERIOD_FIELD_FUNCTION_VALUE_CHANGED = slicePrefix(ActionTypes.travelPeriodField.FunctionValueChanged);
export const FORM_SUBMITTED = slicePrefix(ActionTypes.FormSubmitted);
export const RECENT_SEARCH_TRIGGERED = slicePrefix(ActionTypes.RecentSearchTriggered);
export const setTravelType = travelType => ({
  type: TRAVEL_TYPE_FUNCTION_CHANGED,
  payload: {
    travelType
  }
});
export const setDestinationFieldValue = value => ({
  type: DESTINATION_FIELD_FUNCTION_VALUE_CHANGED,
  payload: {
    value
  }
});
export const setAirportsFieldValue = value => ({
  type: AIRPORTS_FIELD_FUNCTION_VALUE_CHANGED,
  payload: {
    value
  }
});
export const setTravellersFieldValue = value => ({
  type: TRAVELLERS_FIELD_FUNCTION_VALUE_CHANGED,
  payload: {
    value
  }
});
export const setTravellersFieldMultiroomValue = value => ({
  type: TRAVELLERS_FIELD_MULTIROOM_FUNCTION_VALUE_CHANGED,
  payload: {
    value
  }
});
export const setTravelPeriodFieldValue = value => ({
  type: TRAVEL_PERIOD_FIELD_FUNCTION_VALUE_CHANGED,
  payload: {
    value
  }
});